import styled from "styled-components";

import { SessionTypePlaceholderStyledProps as Props } from "./SessionTypePlaceholder.types";
import CONSTANTS from "config/constants";

const { tablet, desktop } = CONSTANTS.BREAKPOINTS;

const SessionTypePlaceholderStyled = styled.div<Props>`
  padding: 1.6rem 0.8rem;

  @media (min-width: ${desktop}px) {
    padding: 1.6rem 0;
  }

  .SessionTypePlaceholder {
    &__cinema {
      width: 40%;
      height: 1.6rem;
    }

    &__separator {
      height: 2;
      margin-top: 1.6rem;
    }

    &__type {
      width: 16%;
      height: 1.2rem;
      margin: 1.6rem 0;
    }

    &__row {
      display: flex;
      justify-content: space-between;
      margin-top: 1.6rem;

      @media (max-width: ${tablet - 1}px) {
        padding: 1.6rem 0;
      }
    }

    &__schedule {
      width: 12rem;
      height: 4rem;
      border-radius: 0.8rem;

      @media (max-width: ${desktop}px) {
        width: 9.6rem;
      }

      @media (max-width: ${tablet}px) {
        width: 12rem;
      }

      @media (max-width: ${tablet - 1}px) {
        width: 10.8rem;
        margin-right: 0.8rem;

        &:not(:nth-last-of-type(-n + 3)) {
          display: none;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
`;

export default SessionTypePlaceholderStyled;
